import React, {useState} from 'react'
import axios from 'axios'

function BrandsItemDetalle(props) {
  const brand = props.brand

  const [inputFile, setInputFile] = useState('')
  const [tituloInput, setTituloInput] = useState('')
  const [descInput, setDescInput] = useState('')

  let idElementoNum = brand.idElement.split('-')[2]
  let tituloString = brand.title + ''
  let descString = brand.description + ''

  const onChangeImage = (event) => {
    setInputFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('home-marcas-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-marcas-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeTitulo = (event) => {
    setTituloInput(event.target.value)
    document.getElementById('ribbon-marcas-' + idElementoNum).classList.remove('d-none')
  }

  const onChangeDesc = (event) => {
    setDescInput(event.target.value)
    document.getElementById('ribbon-marcas-' + idElementoNum).classList.remove('d-none')
  }

  const uploadFile = () => {
    const url = 'https://puntosurgdl.com/backend/'
    const data = new FormData()

    if (document.getElementById('file-marcas-' + idElementoNum).files.length !== 0) {
      for (
        let i = 0;
        i < document.getElementById('file-marcas-' + idElementoNum).files.length;
        i++
      ) {
        data.append('file[]', document.getElementById('file-marcas-' + idElementoNum).files[i])
      }

      data.append('name', props.brand.idElement)

      axios
        .post(url + 'uploadNewBrand.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            console.log(res.data)
            props.setBrands(res.data.data)
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  return (
    <div className='col-lg-3 brand-item' key={brand.idElement}>
      <div className='card card-custom overlay overflow-hidden card-marcas'>
        <div className='card-body p-0'>
          <div id={'ribbon-marcas-' + idElementoNum} className='ribbon-label bg-danger d-none'>
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img src={brand.url} alt='' className='w-100 rounded home-marcas-1' />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-marcas-' + idElementoNum}
                name={'file-marcas-' + idElementoNum}
                className='input-image'
                onChange={() => uploadFile()}
                accept='.png'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() => document.getElementById('file-marcas-' + idElementoNum).click()}
              />
              <input
                id='button'
                type='button'
                value='Eliminar'
                className='btn btn-danger ms-2'
                onClick={() => props.deleteBrand(props.brand.idElement)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {BrandsItemDetalle}
